module.exports = __webpack_public_path__ + "img/astrazeneca-aussetzung.1d48fe47.png";